import { post } from '.';

export function CreateWebRtcParticipant(options = {}) {
	return post<any>("/app/api/web_rtc_participants", options);
}
